import { Component, Input, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { I18nService } from '../../../../../core/services/i18n.service';
import { GetDataService } from '../../../../../layouts/shared/services/get-data.service';
import { BlogService } from '../../services/blog.service';
import { IBlog } from '../../../home-page/interface';
import { IPageInfo } from '../../../../../core/interfaces/interface';
import { SEOService } from '../../../../../core/services/seo.service';
import { DocumentService } from '../../../../../core/services/document.service';
import { Router } from 'express';
@Component({
    selector: 'app-list',
    templateUrl: './list.component.html',
    styleUrl: './list.component.scss',
    standalone: false
})
export class ListComponent {
    blogList = signal<IBlog[]>([]);
    @Input() latestUpdateDate = true;
    latestUpdate = new Date('2025,05,01');
    pageInfo = signal<IPageInfo>(undefined as any);
    targetSEOKey = undefined;
    constructor(
        private i18nService: I18nService,
        private blogService: BlogService,
        private activatedRoute: ActivatedRoute,
        private seo: SEOService,
        private documentService: DocumentService,
        private getDataService: GetDataService,
    ) { }

    ngOnInit() {
        this.getBlogList()

        this.activatedRoute.data.subscribe(({ pageInfoSEOKey }) => {
            this.targetSEOKey = pageInfoSEOKey;
            this.loadSEO(pageInfoSEOKey);
        });
        this.activatedRoute.firstChild?.data.subscribe(({ pageInfoSEOKey }) => {
            this.targetSEOKey = pageInfoSEOKey;
            this.loadSEO(pageInfoSEOKey);
        });

    }
    async getBlogList() {
        this.blogList.set((await this.blogService.getBlogList(this.i18nService.language)));
    }


    loadChanges() {
        this.documentService.goTop();

        this.targetSEOKey = this.activatedRoute.snapshot.data["pageInfoSEOKey"] || this.activatedRoute.firstChild?.snapshot.data["pageInfoSEOKey"];
        if (this.targetSEOKey)
            this.loadSEO(this.targetSEOKey);
    }

    async loadSEO(seoKey: string) {
        if (!seoKey)
            return
        var res = (await this.getDataService.getSEOMetaData(seoKey)) as any;
        if (seoKey == this.targetSEOKey && res) {
            this.pageInfo.set(res);

            this.seo.setPageSEO(res);
        }
    }
}